import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import DebitCardsList from '#client/components/DebitCardList';
import { ASTRA_STATUS } from '#client/constants/astra';
import useAstraProfileContext from '#client/hooks/useAstraProfileContext';
import useSkeleton from '#client/hooks/useSkeleton';

import EmptyState from './EmptyState';
import ListItemSkeleton from './ListItemSkeleton';

export default function DebitCardsOriginal({
  accounts,
  loading = false,
  addDebitCardHandler,
  createBankingCardForInstantFunding,
  isDailyTransferLimitExceeded
}) {
  const [showSkeleton] = useSkeleton(!loading && !!accounts);
  const { accountStatus, isEligibleForTransfers } = useAstraProfileContext();

  /**
   * Return null when:
   * 1. Astra account status is suspended or isEligibleForTransfers is false
   * 2. Empty card list
   */
  if (
    accounts &&
    accounts.length === 0 &&
    (accountStatus === ASTRA_STATUS.SUSPENDED || !isEligibleForTransfers)
  ) {
    return null;
  }

  return (
    <Stack>
      {showSkeleton ? (
        <ListItemSkeleton />
      ) : (
        <>
          <Box
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Text
              size="lg"
              weight="medium"
            >
              External Debit Cards
            </Text>
          </Box>
          <Box>
            {accounts && accounts.length > 0 ? (
              <DebitCardsList
                createBankingCardForInstantFunding={createBankingCardForInstantFunding}
                debitCards={accounts}
                isDailyTransferLimitExceeded={isDailyTransferLimitExceeded}
                loadingAccounts={loading}
                usedAt="dashboard"
              />
            ) : (
              <Box
                p="16px 0px"
                textAlign="center"
              >
                <EmptyState
                  onClick={addDebitCardHandler}
                  text="Add a card"
                />
              </Box>
            )}
          </Box>
        </>
      )}
    </Stack>
  );
}

DebitCardsOriginal.propTypes = {
  addDebitCardHandler: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  accounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  createBankingCardForInstantFunding: PropTypes.func.isRequired,
  isDailyTransferLimitExceeded: PropTypes.bool
};
